module.exports = __webpack_public_path__ + "img/210.a94a4bb6.jpeg";